function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9 18.7a.99.99 0 101.4-1.4l-4.593-4.593a1 1 0 00-1.414 0L10.7 17.3a.99.99 0 101.4 1.4l3.9-3.9 3.9 3.9z",
  fill: "#6F8190"
});

var SvgIconArrowUp = function SvgIconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS45IDE4LjdDMjAuMjg2NiAxOS4wODY2IDIwLjkxMzQgMTkuMDg2NiAyMS4zIDE4LjdDMjEuNjg2NiAxOC4zMTM0IDIxLjY4NjYgMTcuNjg2NiAyMS4zIDE3LjNMMTYuNzA3MSAxMi43MDcxQzE2LjMxNjYgMTIuMzE2NiAxNS42ODM0IDEyLjMxNjYgMTUuMjkyOSAxMi43MDcxTDEwLjcgMTcuM0MxMC4zMTM0IDE3LjY4NjYgMTAuMzEzNCAxOC4zMTM0IDEwLjcgMTguN0MxMS4wODY2IDE5LjA4NjYgMTEuNzEzNCAxOS4wODY2IDEyLjEgMTguN0wxNiAxNC44TDE5LjkgMTguN1oiIGZpbGw9IiM2RjgxOTAiLz4KPC9zdmc+Cg==";
export { SvgIconArrowUp as ReactComponent };